var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _path0, _path1, _path10, _g4, _path11, _path12, _path13, _g5, _path14, _path15, _path16, _g6, _path17, _path18, _path19, _g7, _path20, _path21, _path22, _g8, _path23, _path24, _path25, _g9, _path26, _path27, _path28, _g0, _path29, _g1, _path30, _path31, _path32, _path33, _g10, _path34, _g11, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourIconFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 68,
    viewBox: "0 0 117 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 36,
    width: 15,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.665 36.9908H92.591V59.427H78.665V36.9908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 18,
    width: 48,
    height: 51
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1825 18.656L125.353 30.823L111.591 68.3457L78.4167 56.1756L92.1825 18.656Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 18,
    width: 48,
    height: 51
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1825 18.656L125.353 30.823L111.591 68.3457L78.4167 56.1756L92.1825 18.656Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.0161 39.2577L86.1622 37.109C85.8056 36.979 85.4067 37.1634 85.2737 37.523L79.6677 52.8089C78.9454 54.7793 79.9608 56.9734 81.9312 57.6957L84.8597 58.7716C85.2163 58.9015 85.6182 58.7172 85.7482 58.3575L86.821 55.4321L92.4301 40.1462C92.56 39.7896 92.3757 39.3877 92.0161 39.2577Z",
    fill: "#FFCA55"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 21,
    width: 42,
    height: 47
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9354 21.5174H116.94V67.9372H75.9354V21.5174Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0381 18.6557L117.209 30.8228L103.446 68.3454L70.2723 56.1753L84.0381 18.6557Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0381 18.6557L117.209 30.8228L103.446 68.3454L70.2723 56.1753L84.0381 18.6557Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.969 29.6352L93.1558 21.9983C91.3607 21.3425 89.3691 22.2643 88.7103 24.0594L76.3045 57.883C76.1715 58.2396 76.3589 58.6385 76.7155 58.7715L100.131 67.3604C101.926 68.0192 103.918 67.0975 104.576 65.3023L116.03 34.0808C116.689 32.2856 115.764 30.2941 113.969 29.6352Z",
    fill: "#FFCA55"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 26,
    width: 10,
    height: 12
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6136 26.1804H100.898V37.7853H91.6136V26.1804Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 19,
    width: 48,
    height: 51
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5637 19.45L119.735 31.617L105.972 69.1397L72.798 56.9696L86.5637 19.45Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 19,
    width: 48,
    height: 51
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5637 19.45L119.735 31.617L105.972 69.1397L72.798 56.9696L86.5637 19.45Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.444 36.0024C100.614 34.5366 100.088 33.1344 99.1055 32.131C99.6978 31.8228 100.187 31.309 100.435 30.6351C100.964 29.1965 100.224 27.5948 98.7852 27.069C97.3466 26.5401 95.7479 27.2835 95.2191 28.719C94.9712 29.396 95.0136 30.1062 95.2674 30.7227C93.8863 30.8496 92.5898 31.5629 91.7708 32.7687C91.6741 32.8956 91.6227 33.0528 91.6288 33.219C91.6318 33.3066 91.653 33.3973 91.6922 33.4849C92.3178 35.0595 93.5901 36.2985 95.1919 36.8848C96.7966 37.4741 98.5857 37.3502 100.094 36.5373C100.166 36.498 100.23 36.4466 100.281 36.3922C100.363 36.2834 100.426 36.1504 100.444 36.0024Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 31,
    width: 6,
    height: 5
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M103.249 31.9984H108.665V35.8667H103.249V31.9984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 20,
    width: 47,
    height: 51
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8209 20.6261L118.992 32.7932L105.229 70.3158L72.0552 58.1457L85.8209 20.6261Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 20,
    width: 47,
    height: 51
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8209 20.6262L118.992 32.7932L105.229 70.3159L72.0552 58.1458L85.8209 20.6262Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.812 34.0596L107.157 35.2866C107.514 35.4166 107.913 35.2322 108.046 34.8726C108.176 34.516 107.991 34.1171 107.635 33.9841L104.289 32.7571C103.933 32.6271 103.534 32.8115 103.401 33.1711C103.271 33.5277 103.449 33.9267 103.812 34.0596Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 34,
    width: 9,
    height: 8
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.504 35.9147L108.838 34.9072L109.575 40.2725L102.241 41.28L101.504 35.9147Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 22,
    width: 29,
    height: 48
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6769 22.2929L112.793 31.2613L108.581 69.715L84.4624 60.7439L88.6769 22.2929Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 22,
    width: 29,
    height: 48
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6769 22.2929L112.793 31.2613L108.581 69.715L84.4624 60.7439L88.6769 22.2929Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.27 37.7282L108.857 40.1758C109.119 40.2741 109.363 40.0513 109.405 39.6857C109.444 39.3203 109.265 38.9393 109.004 38.844L102.416 36.3933C102.157 36.2978 101.912 36.5175 101.871 36.8832C101.832 37.2515 102.006 37.6272 102.27 37.7282Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 36,
    width: 24,
    height: 11
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7662 36.2171H109.202V46.2747H86.7662V36.2171Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0377 18.6557L117.209 30.8227L103.446 68.3454L70.272 56.1753L84.0377 18.6557Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0377 18.6557L117.209 30.8227L103.446 68.3454L70.272 56.1753L84.0377 18.6557Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.7946 38.2663L107.535 45.5103C107.892 45.6402 108.291 45.4559 108.424 45.0963C108.554 44.7396 108.369 44.3407 108.013 44.2077L88.2721 36.9667C87.9125 36.8368 87.5136 37.0211 87.3806 37.3778C87.2507 37.7374 87.435 38.1363 87.7946 38.2663Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 40,
    width: 23,
    height: 11
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2194 40.8594H107.656V50.1433H85.2194V40.8594Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0377 18.6559L117.209 30.8229L103.446 68.3456L70.272 56.1755L84.0377 18.6559Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0377 18.6559L117.209 30.8229L103.446 68.3456L70.272 56.1755L84.0377 18.6559Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.483 48.3934L86.7363 41.1494C86.3767 41.0164 85.9777 41.2038 85.8478 41.5604C85.7148 41.9201 85.9022 42.319 86.2588 42.4489L105.999 49.693C106.356 49.8229 106.758 49.6386 106.888 49.2789C107.021 48.9223 106.839 48.5234 106.483 48.3934Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 44,
    width: 24,
    height: 11
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.672 44.7273H106.108V54.0113H83.672V44.7273Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0377 18.6557L117.209 30.8227L103.446 68.3454L70.272 56.1753L84.0377 18.6557Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0377 18.6557L117.209 30.8227L103.446 68.3454L70.272 56.1753L84.0377 18.6557Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.948 52.576L85.2016 45.332C84.845 45.199 84.4431 45.3864 84.3131 45.743C84.1832 46.0996 84.3675 46.5015 84.7241 46.6315L104.465 53.8725C104.824 54.0055 105.223 53.8211 105.356 53.4615C105.486 53.1049 105.308 52.7059 104.948 52.576Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 49,
    width: 23,
    height: 10
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1251 49.3693H104.561V58.6533H82.1251V49.3693Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0383 18.6555L117.209 30.8226L103.446 68.3453L70.2726 56.1752L84.0383 18.6555Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0383 18.6555L117.209 30.8226L103.446 68.3453L70.2726 56.1752L84.0383 18.6555Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.416 56.7585L83.6696 49.5145C83.31 49.3815 82.911 49.5689 82.7781 49.9255C82.6481 50.2821 82.8325 50.684 83.1921 50.814L102.933 58.055C103.289 58.1879 103.688 58.0006 103.821 57.644C103.951 57.2874 103.773 56.8884 103.416 56.7585Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 53,
    width: 24,
    height: 10
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5771 53.2379H103.013V62.5218H80.5771V53.2379Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0382 18.656L117.209 30.8231L103.446 68.3457L70.2725 56.1756L84.0382 18.656Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1_9343)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 18,
    width: 48,
    height: 51
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0382 18.656L117.209 30.8231L103.446 68.3457L70.2725 56.1756L84.0382 18.656Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.88 60.9413L82.1336 53.6973C81.774 53.5643 81.3751 53.7517 81.2451 54.1083C81.1122 54.4649 81.2995 54.8668 81.6561 54.9968L101.397 62.2378C101.753 62.3708 102.155 62.1834 102.285 61.8268C102.418 61.4702 102.24 61.0713 101.88 60.9413Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 11,
    width: 26,
    height: 26
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0947 11H66.5699V36.3558H41.0947V11Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8717 36.2114C60.8052 36.2114 66.4451 30.5691 66.4451 23.638C66.4451 16.7095 60.8052 11.0671 53.8717 11.0671C46.9407 11.0671 41.3008 16.7095 41.3008 23.638C41.3008 30.5691 46.9407 36.2114 53.8717 36.2114Z",
    fill: "#662D91"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6644 41.518C80.8241 41.518 85.026 37.3211 85.026 32.1614C85.026 27.0017 80.8241 22.8022 75.6644 22.8022C70.5046 22.8022 66.3027 27.0017 66.3027 32.1614C66.3027 37.3211 70.5046 41.518 75.6644 41.518Z",
    fill: "#662D91"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0814 41.518C37.2411 41.518 41.4405 37.3211 41.4405 32.1614C41.4405 27.0017 37.2411 22.8022 32.0814 22.8022C26.9216 22.8022 22.7197 27.0017 22.7197 32.1614C22.7197 37.3211 26.9216 41.518 32.0814 41.518Z",
    fill: "#662D91"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2165 44.3316C68.1717 44.2819 68.1244 44.2346 68.0821 44.1848C67.6244 43.6848 67.1417 43.2096 66.6367 42.7593C66.5894 42.7195 66.5447 42.6747 66.4999 42.6349C65.3903 41.6672 64.1688 40.8213 62.8577 40.1247C62.8179 40.0998 62.7707 40.0849 62.7308 40.0625C62.1537 39.7615 61.5641 39.4978 60.957 39.2515C60.7754 39.1818 60.5913 39.1172 60.4047 39.055C59.9221 38.8758 59.432 38.7191 58.932 38.5848C58.7081 38.5251 58.4792 38.4604 58.2503 38.4081C57.7527 38.2912 57.2452 38.2041 56.7327 38.122C56.5138 38.0922 56.3048 38.0524 56.0834 38.025C55.357 37.9404 54.6206 37.8882 53.8718 37.8882C53.1229 37.8882 52.3865 37.9404 51.6601 38.025C51.4412 38.0524 51.2272 38.0922 51.0108 38.122C50.5008 38.2041 49.9908 38.2912 49.4932 38.4081C49.2618 38.4604 49.0379 38.5251 48.8115 38.5848C48.3115 38.7191 47.8214 38.8758 47.3388 39.055C47.1547 39.1172 46.9656 39.1818 46.7865 39.2515C46.1794 39.4978 45.5849 39.7665 45.0127 40.0625C44.9679 40.0849 44.9256 40.0998 44.8833 40.1247C43.5747 40.8213 42.3532 41.6672 41.2436 42.6349C41.1964 42.6747 41.1541 42.7195 41.1093 42.7593C40.6043 43.2096 40.1216 43.6848 39.6614 44.1848C39.6166 44.2346 39.5743 44.2819 39.527 44.3316C39.0469 44.869 38.5941 45.4287 38.1762 46.0134C35.9297 49.1654 34.5962 53.0116 34.5962 57.1662C34.5962 60.4004 37.2283 63.0325 40.4625 63.0325H67.2835C70.5177 63.0325 73.1498 60.4004 73.1498 57.1662C73.1498 53.0116 71.8138 49.1654 69.5698 46.0134C69.1519 45.4287 68.6941 44.869 68.2165 44.3316Z",
    fill: "#662D91"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 43,
    width: 16,
    height: 21
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18 43.9983H33.4518V63.1047H18V43.9983Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0808 44.593C24.2243 44.593 17.8331 50.9842 17.8331 58.8407C17.8331 61.1519 19.7139 63.0327 22.0226 63.0327H31.3096C30.2175 61.336 29.5656 59.3308 29.5656 57.1664C29.5656 52.5864 30.8643 48.3123 33.0735 44.6527C32.7451 44.6304 32.4167 44.593 32.0808 44.593Z",
    fill: "#662D91"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1_9343",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 43,
    width: 16,
    height: 21
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2124 43.9983H90.0001V63.1047H74.2124V43.9983Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1_9343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6652 44.593C75.3294 44.593 75.001 44.6304 74.6726 44.6527C76.8818 48.3123 78.1804 52.5864 78.1804 57.1664C78.1804 59.3308 77.5286 61.336 76.4365 63.0327H85.7235C88.0322 63.0327 89.9129 61.1519 89.9129 58.8407C89.9129 50.9842 83.5218 44.593 75.6652 44.593Z",
    fill: "#662D91"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0031 16.0322C94.0014 14.9132 94.9071 14.0047 96.0261 14.0031C97.1451 14.0014 98.0536 14.9071 98.0553 16.0261C98.0569 17.1451 97.1512 18.0536 96.0322 18.0553C94.9132 18.0569 94.0047 17.1512 94.0031 16.0322Z",
    fill: "#D0BEDD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.005 9.3341C86.0022 7.49827 87.4892 6.00779 89.325 6.00502C91.1609 6.00225 92.6523 7.48823 92.6551 9.32407C92.6578 11.1599 91.1709 12.6504 89.3351 12.6532C87.4992 12.6559 86.0078 11.1699 86.005 9.3341Z",
    fill: "#D0BEDD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93136 39.9834C4.92956 38.7901 5.89608 37.8213 7.08937 37.8195C8.28266 37.8177 9.2521 38.7836 9.2539 39.9769C9.2557 41.1702 8.28918 42.139 7.09589 42.1408C5.9026 42.1426 4.93316 41.1767 4.93136 39.9834Z",
    fill: "#D0BEDD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M26.005 10.3341C26.0022 8.49827 27.4892 7.00779 29.325 7.00502C31.1609 7.00225 32.6523 8.48823 32.6551 10.3241C32.6578 12.1599 31.1709 13.6504 29.3351 13.6532C27.4992 13.6559 26.0078 12.1699 26.005 10.3341Z",
    fill: "#D0BEDD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0.860118 47.5498C0.857348 45.7139 2.3443 44.2235 4.18013 44.2207C6.01596 44.2179 7.5074 45.7039 7.51017 47.5397C7.51294 49.3756 6.02599 50.8661 4.19016 50.8688C2.35433 50.8716 0.862888 49.3856 0.860118 47.5498Z",
    fill: "#D0BEDD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M107.327 60.931C107.324 59.0951 108.811 57.6047 110.647 57.6019C112.483 57.5991 113.974 59.0851 113.977 60.9209C113.98 62.7568 112.493 64.2473 110.657 64.25C108.821 64.2528 107.33 62.7668 107.327 60.931Z",
    fill: "#D0BEDD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M110.234 53.6259C110.232 52.609 111.056 51.7833 112.073 51.7818C113.09 51.7802 113.916 52.6034 113.918 53.6204C113.919 54.6373 113.096 55.463 112.079 55.4645C111.062 55.4661 110.235 54.6429 110.234 53.6259Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIconFive);
export default __webpack_public_path__ + "static/media/tour_icon_five.2d485b9b418f00c91f622a966033ac5d.svg";
export { ForwardRef as ReactComponent };